import { useTranslation } from 'react-i18next'

import { EntityTabSubTabs } from '../../../EntityTab'
import {
  getRequestProfileTabAttachedRequestsSubTabItems,
  getRequestProfileTabAttachedRequestsSubTabQaName,
} from '../RequestProfileTabAttachedRequests.utils'

import * as styles from './RequestProfileTabAttachedRequestsSubTabs.module.css'

function RequestProfileTabAttachedRequestsSubTabs({
  activeSubTab,
  counters,
  onSetActiveSubTab,
}) {
  const { t } = useTranslation()

  const items = getRequestProfileTabAttachedRequestsSubTabItems({ counters, t })

  return (
    <EntityTabSubTabs
      activeValue={activeSubTab}
      className={styles.subTabs}
      getItemQaName={getRequestProfileTabAttachedRequestsSubTabQaName}
      items={items}
      onChange={onSetActiveSubTab}
    />
  )
}

export default RequestProfileTabAttachedRequestsSubTabs
